export default __webpack_public_path__ + "static/media/882.260eea08.png";